export default __webpack_public_path__ + "static/media/ga.e21adece.svg";